import React from "react";
import {Document, Page, Text, View} from '@react-pdf/renderer';
import {PdfPostControlDocumentAttachments} from './PdfPostControlDocumentAttachments';
import {stylesForPdf} from './PdfPostControlStyling';
import {renderOrdersTable} from './PdfPostControlOrders';
import {getTextWithLines, getDividedStringIntoSpans} from '../documents/helpers';
import {isWTrakcieRealizacji} from "../ControlStateHelper";
import { draftjsToString } from '../WysiwygEditor/WysiwygHelpers';


export default class PdfNote extends React.Component {
    printPickedWops = (control) => {
		let wopsCollection = control.paymentClaims;
		if (wopsCollection?.length > 0) {
			return <Text>{wopsCollection.map(item => item.number).join(', ').match(/.{1,5}/g)}</Text>;
		} else {
			return <Text>Brak kontrolowanych wniosków</Text>
		}
	};

    render = () => {
        let {control, infoData, infoNumber} = this.props;
        let generationTime = new Date(Date.now()).toLocaleString();
        return (
            <Document>
                <Page style={stylesForPdf.body}>

                        {/* nagłówek */}
                        <Text style={stylesForPdf.pageHeader} fixed>
                            {`${infoNumber}\nUtworzono ${generationTime}`}
                        </Text>

                        {/* tytuł dokumentu */}
                        <View>
                            {isWTrakcieRealizacji(control) &&
                                <Text style={stylesForPdf.draft} fixed>WERSJA ROBOCZA</Text>}
                            <Text style={stylesForPdf.mainTitleInVER2}>{`NOTATKA POKONTROLNA\n${infoNumber}`}</Text>
                        </View>

                        {/* informacje wstępne */}
                        <View style={stylesForPdf.sectionTitle2View}>
                            <Text style={stylesForPdf.sectionTitle2}>{getTextWithLines('Informacje o projekcie')}</Text>
                        </View>
                        <View style={stylesForPdf.table}>
                            <View style={stylesForPdf.tableRow}>
                                <Text style={stylesForPdf.tableCol}>Numer kontroli:</Text>
                                <Text>{control.number}</Text>
                            </View>
                            <View style={stylesForPdf.tableRow}>
                                <Text style={stylesForPdf.tableCol}>Numer projektu:</Text>
                                <Text>{control.project.metadata.businessId}</Text>
                            </View>
                            <View style={stylesForPdf.tableRow}>
                                <Text style={stylesForPdf.tableCol}>Tytuł projektu:</Text>
                                <Text>{control.project.title}</Text>
                            </View>
                        </View>

                        {/* Dane beneficjenta */}
                        <View style={stylesForPdf.sectionTitle2View}>
                            <Text style={stylesForPdf.sectionTitle2}>{getTextWithLines('Dane beneficjenta')}</Text>
                        </View>
                        <View style={stylesForPdf.table}>
                            <View style={stylesForPdf.tableRow}>
                                <Text style={stylesForPdf.tableCol}>Identyfikator beneficjenta:</Text>
                                <Text>{control.project.beneficiaryIdentityNumber}</Text>
                            </View>
                            <View style={stylesForPdf.tableRow}>
                                <Text style={stylesForPdf.tableCol}>Nazwa beneficjenta:</Text>
                                <Text>{control.project.beneficiaryName}</Text>
                            </View>
                            <View style={stylesForPdf.tableRow}>
                                <Text style={stylesForPdf.tableCol}>Adres beneficjenta:</Text>
                                <Text>{control.project.beneficiaryAddress}</Text>
                            </View>
                        </View>

                        {/* Informacje o kontroli */}
                        <View style={stylesForPdf.sectionTitle2View}>
                            <Text style={stylesForPdf.sectionTitle2}>{getTextWithLines('Informacje o kontroli')}</Text>
                        </View>
                        <View style={stylesForPdf.tableTop}>
                            <View style={stylesForPdf.tableRow}>
                                <Text style={stylesForPdf.tableCol}>Tryb kontroli:</Text>
                                <Text>{control.controlMode}</Text>
                            </View>
                            <View style={stylesForPdf.tableRow}>
                                <Text style={stylesForPdf.tableCol}>Typ kontroli:</Text>
                                <Text>{control.controlType}</Text>
                            </View>
                            <View style={stylesForPdf.tableRow}>
                                <Text style={stylesForPdf.tableCol}>Rodzaj kontroli:</Text>
                                <Text>{control.controlKind}</Text>
                            </View>
                            <View style={stylesForPdf.tableRow}>
                                <Text style={stylesForPdf.tableCol}>Zespół kontrolujący:</Text>
                                <Text>{control.controlTeam}</Text>
                            </View>
                            <View style={stylesForPdf.tableRow}>
                                <Text style={stylesForPdf.tableCol}>Zastosowana lista sprawdzająca:</Text>
                                <Text>{control.questionList.name}</Text>
                            </View>
                            <View style={stylesForPdf.tableRow}>
                                <Text style={stylesForPdf.tableCol}>Planowany termin kontroli:</Text>
                                <Text>{control.plannedTerm}</Text>
                            </View>
                            <View style={stylesForPdf.tableRow}>
                              <Text style={stylesForPdf.tableCol}>Data rozpoczęcia kontroli:</Text>
                              <Text>{control.term}</Text>
                            </View>
                            <View style={stylesForPdf.tableRow}>
                                <Text style={stylesForPdf.tableCol}>Podmiot kontrolujący:</Text>
                                <Text>{control?.controllingEntity?.split('')}</Text>
                            </View>
                            <View style={stylesForPdf.tableRow}>
                                <Text style={stylesForPdf.tableCol}>Podmioty kontrolowane:</Text>
                                <Text>{control?.allControlledParties?.split('')}</Text>
                            </View>
                            <View style={stylesForPdf.tableRow}>
                                <Text style={stylesForPdf.tableCol}>Miejsca przeprowadzenia kontroli:</Text>
                                <Text>{(control.controlPlaces && control.controlPlaces.length>0 ? control.controlPlaces.map(p=>p.name).join("; ") : 'Brak').split('')}</Text>
                            </View>
                            <View style={stylesForPdf.tableRow}>
                                <Text style={stylesForPdf.tableCol}>Inne kontrolowane projekty:</Text>
                                <Text>{(control.otherControlledProjectNumbers && control.otherControlledProjectNumbers.length > 0 ? control.otherControlledProjectNumbers.join("; ") : 'Brak innych kontrolowanych projektów').split('')}</Text>
                            </View>
                            <View style={stylesForPdf.tableRow}>
                                <Text style={stylesForPdf.tableCol}>Kontrolowane zamówienia:</Text>
                                <Text>{(!control.orders || control.orders?.length === 0 ? 'Brak kontrolowanych zamówień' : '').split('')}</Text>
                            </View>
                        </View>
                        {renderOrdersTable(this.props.control.orders)}
                        <View style={!control.orders || control.orders?.length === 0 ? stylesForPdf.tableBottomNoMargin : stylesForPdf.tableBottom}>
                            <View style={stylesForPdf.tableRow}>
                                <Text style={stylesForPdf.tableCol}>Numery kontrolowanych WoP:</Text>
                                {this.printPickedWops(control)}
                            </View>
                        </View>
                        <View>
                            <Text style={stylesForPdf.sectionLowerMargin}>Treść notatki</Text>
                        </View>
                        <View>
                            <Text style={stylesForPdf.note}>{draftjsToString(infoData.noteContent)}</Text>
                        </View>
                        <View>
                          <Text style={stylesForPdf.sectionLowerMargin}>Załączniki</Text>
                          <PdfPostControlDocumentAttachments attachments={control.documents} attachmentsInDocument={infoData.attachments} />
                        </View>

                    {/* stopka */}
                    <Text style={stylesForPdf.pageNumber} render={({ pageNumber, totalPages }) => (
                        `Strona ${pageNumber} z ${totalPages}`
                    )} fixed />
                </Page>
            </Document>
        )
    };


}
